var map = {
	"./burger.svg": 3001,
	"./check.svg": 3658,
	"./close-black.svg": 9700,
	"./logo-modal.svg": 1327,
	"./mail.svg": 8839,
	"./phone.svg": 282,
	"./social/fb.svg": 4282,
	"./social/ig.svg": 5186,
	"./social/rabota.svg": 3981,
	"./social/work.svg": 5281,
	"./social/x.svg": 9678
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9542;